var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02379 8.23966C6.58547 8.23966 6.23014 8.61276 6.23014 9.073C6.23014 9.53323 6.58547 9.90633 7.02379 9.90633H12.9762C13.4145 9.90633 13.7698 9.53323 13.7698 9.073C13.7698 8.61276 13.4145 8.23966 12.9762 8.23966H7.02379ZM16.3492 9.073C16.3492 12.6853 13.5235 15.6458 9.99998 15.6458C6.47642 15.6458 3.65078 12.6853 3.65078 9.073C3.65078 5.46066 6.47642 2.50016 9.99998 2.50016C13.5235 2.50016 16.3492 5.46066 16.3492 9.073ZM13.6764 16.377C12.5773 16.9745 11.3267 17.3125 9.99998 17.3125C5.61677 17.3125 2.06348 13.6235 2.06348 9.073C2.06348 4.52244 5.61677 0.833496 9.99998 0.833496C14.3832 0.833496 17.9365 4.52244 17.9365 9.073C17.9365 11.1095 17.2248 12.9734 16.0456 14.4114L17.2398 15.6594C17.8266 16.2726 17.8288 17.2692 17.2448 17.8854C16.6608 18.5015 15.7116 18.5039 15.1248 17.8906L13.6764 16.377Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.4cbea1a83e1399e1187478924afe38be.svg";
export { ForwardRef as ReactComponent };